import * as fromDeclinedReasons from './declined-reasons.actions';
import { declinedReasonsAdapter, DeclinedReasonsState, initialState } from './declined-reasons.interfaces';

export function reducer(
  state: DeclinedReasonsState = initialState,
  action: fromDeclinedReasons.DeclinedReasonsAction
): DeclinedReasonsState {
  switch (action.type) {
    case fromDeclinedReasons.GET_DECLINED_REASONS_FROM_SERVER_SUCCESS: {
      return {
        ...declinedReasonsAdapter.addMany(action.payload.declinedReasons, state)
      };
    }

    default: {
      return state;
    }
  }
}
